import React, { Component } from 'react';
import { getFileName } from 'helpers/FileCaching';
import classes from './Quote.module.scss';
import SocialIcons from '../../../App/SocialIcons/SocialIcons';
import globalJSON from 'data/global.json';
const quoteAssets = require.context('images/components/Articles/Article/Quote', true, /.*\.(gif|png|jpe?g|svg)$/i);


class Quote extends Component {

    render(){
        return (
            <div className={classes.quote}>
                
                <div className={classes.quote__wrap} style={{top:this.props.content.position.top[this.props.windowSize] + 'px'}}>
                    <div className={classes.quote__icon} style ={ { backgroundImage: "url("+  getFileName(quoteAssets, 'quote-icon.svg') +")" } }></div>
                    <h4 className={classes.quote__text} dangerouslySetInnerHTML={{__html: this.props.content.text}}></h4>
                    <div className={classes.quote__quoteSocialContainer}>
                        <div className={`divider ${classes.quote__divider}`}></div>
                        <SocialIcons content={this.props.socialContent} url={`${globalJSON.live_url}${process.env.PUBLIC_URL}/${this.props.url}`}/>
                    </div>
                </div>

            </div>
        );
    }
}

export default Quote;